import ReactDOM from "react-dom/client";

import { IdpDiscovery } from "common-services/features/login/IdpDiscovery";
import { PasswordLogin } from "common-services/features/login/PasswordLogin";
import { ProviderDiscovery } from "common-services/features/login/ProviderDiscovery";
import { App } from "shell/console/components/App";
import { LoginFlowProvider } from "shell/platform/contexts/LoginFlowContext";
import { initGlobals } from "shell/platform/lib/initGlobals";

initGlobals();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <LoginFlowProvider
    components={{ PasswordLogin, ProviderDiscovery, IdpDiscovery }}
  >
    <App />
  </LoginFlowProvider>,
);
